import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useLoaderData, useSubmit } from 'react-router';
import Page from 'client/components/aria/Page/Page';
import Markdown from 'client/components/aria/MarkDown/Markdown';
import PropTypes from 'prop-types';
import { usePageTitle } from './usePageTitle';

const CMSPage = ({ title, testId }) => {
    const { content } = useLoaderData();
    const submit = useSubmit();
    const currentLocale = useSelector(state => state?.locale?.current);
    const locale = useRef(currentLocale);
    const pageTitle = usePageTitle(title);
    useEffect(() => {
        if (locale?.current !== currentLocale) {
            // Reload CMS page when locale changed, to trigger loader re-fetch
            submit(null);
        }
    }, [currentLocale]);

    return (
        <Page
            title={pageTitle}
            data-testid={testId}
        >
            <div className="govuk-grid-row">
                <div className="govuk-grid-column-full">
                    <Markdown>
                        { content?.markdown }
                    </Markdown>
                </div>
            </div>
        </Page>
    );
};

CMSPage.propTypes = {
    title: PropTypes.string.isRequired,
    testId: PropTypes.string
};

CMSPage.defaultProps = {
    testId: 'cmsPage'
};

export default CMSPage;
